'use strict'

import {Enum} from '@/app/model/base/enum'

const values = {
  SUCCESS: 0,
  INVALID_REQUEST: 1,
  ACCESS_DENIED: 2,
  UNKNOWN: 'F_UNKNOWN',
  NO_CONNECTION: 'F_NO_CONNECTION'
}

class ApiResponseCode extends Enum {
  isUnknown() {
    return this.value === ApiResponseCode.UNKNOWN.value
  }

  isAccessDenied() {
    return this.value === ApiResponseCode.ACCESS_DENIED.value
  }

  isSuccess() {
    return this.value === ApiResponseCode.SUCCESS.value
  }
}

export default ApiResponseCode.initEnum(values)
